import { TooltipPlusIcon } from './TooltipPlusIcon';

/**
 * author: Austin Andrews
 * id E1ED044C-BD73-4844-A33D-7ED9A1D232F5
 * name tooltip-plus
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-plus.svg
 * tags
 * - Tooltip 
 */
export const TooltipAddIcon = TooltipPlusIcon;
export default TooltipAddIcon